import type { ReactNode } from 'react';
import { ClipboardList, type LucideIcon } from 'lucide-react';
import StateBlock from './ui/StateBlock';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
}

/** Thin wrapper over `ui/StateBlock kind="empty"` (T-38); kept for existing call sites. */
export default function EmptyState({ icon = ClipboardList, title, description, action }: EmptyStateProps) {
  return <StateBlock kind="empty" size="panel" icon={icon} title={title} description={description} action={action} />;
}
